module.exports = __webpack_public_path__ + "img/ss.dc3fdf90.svg";